export default "__VITE_ASSET__Db5Cr3xQ__"